import { useDispatch } from 'react-redux';
import { activateSink, loadDataSink } from 'js/actions';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import { tryCatchAsync } from 'new/utils/TryCatch';
import { useCallback } from 'react';

export default function useSinksAdapter() {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  function requestSinkById({
    id,
    ignoreErrors = undefined,
    aclQueryMode = ACLQueryModeTypes.MODE_OWNER.key,
  }) {
    return dispatch(loadDataSink(id, { aclQueryMode, ignoreErrors }));
  }

  async function getSinkById(
    id: any,
    ignoreErrors = undefined,
    aclQueryMode = ACLQueryModeTypes.MODE_OWNER.key,
  ) {
    const request = requestSinkById({ id, ignoreErrors, aclQueryMode });
    const { error, data } = await tryCatchAsync(request);

    if (error) throw new Error(error?.message);

    return data.entities.sinks[id];
  }

  const activate = useCallback(
    (id: number) => {
      return dispatch(activateSink(id));
    },
    [dispatch],
  );

  return {
    activate,
    getSinkById,
    requestSinkById,
  };
}
